// extracted by mini-css-extract-plugin
export default {"img":"PostImage_img__-55zI"};